import modalTorFormUrl from './modal-tor-form.html';

export default function torForm() {
  return {
    templateUrl: modalTorFormUrl,
    controllerProvider: async () =>
      (await import(/* webpackChunkName: "shifts" */ '../EditTimeOffRequestCtrl')).default,
    controllerAs: 'ctrl',
    scope: {
      request: '=',
      modal: '=',
    },
  };
}
